/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Maxwidth1Inputs */

const en_entity_maxwidth1 = /** @type {(inputs: Entity_Maxwidth1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max Width`)
};

const de_entity_maxwidth1 = /** @type {(inputs: Entity_Maxwidth1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximale Breite`)
};

/**
* | output |
* | --- |
* | "Max Width" |
*
* @param {Entity_Maxwidth1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_maxwidth1 = /** @type {((inputs?: Entity_Maxwidth1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Maxwidth1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_maxwidth1(inputs)
	return de_entity_maxwidth1(inputs)
});
export { entity_maxwidth1 as "entity_maxWidth" }